import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

const { Content } = Layout;

const FlowLayoutShell = ({ contentClassName }) => (
    <Layout className='layout'>
        <Content className={contentClassName}>
            <Outlet />
        </Content>
    </Layout>
);

export default FlowLayoutShell;
